import InscripcionService from '../services/inscripcion.service';
import ModalHistorialesEstadosAcademicos from '../components/ModalHistorialesEstadosAcademicos.vue';
import { ESTADOS_ACADEMICOS } from '../utils/constantes';

export default {
  components: {
    ModalHistorialesEstadosAcademicos,
  },
  data() {
    return {
      inscripcion: [],
      obteniendoInscripcion: false,
      estadosAcademicos: ESTADOS_ACADEMICOS,
    };
  },
  methods: {
    obtenerInscripcionConHistorialEstadosAcademicos(inscripcionId) {
      this.obteniendoInscripcion = true;

      InscripcionService.findConHistorialEstadosAcademicos(inscripcionId)
        .then((response) => {
          const data = response?.data;

          this.inscripcion = data?.datos;
          this.$refs.modalHistorialesEstadosAcademicosRef.abrir();
        })
        .catch(() => {
          window.console.error('Error al obtener la inscripción');
        })
        .finally(() => {
          this.obteniendoInscripcion = false;
        });
    },
  },
};
